<template>
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_731_92566)">
      <rect
        x="6"
        y="4"
        width="48"
        height="48"
        rx="24"
        fill="url(#paint0_radial_731_92566)"
      />
      <g clip-path="url(#clip0_731_92566)">
        <g filter="url(#filter1_di_731_92566)">
          <path
            d="M29.6443 14.3264C21.9711 14.5136 15.887 20.0938 16.0016 26.8113C16.277
            33.6589 21.9944 39.2937 29.6749 41.0166C30.2878 41.0933 31.0445 41.236
            31.8627 41.3911C32.9473 41.5227 34.0611 41.5834 35.1971 41.5557C35.4779
            41.5488 35.7571 41.5364 36.0347 41.5191C36.63 41.4819 37.1804 41.0835
            36.945 40.6037C36.8619 40.4344 36.7361 40.2655 36.5647 40.1068C35.5748
            39.1905 36.0062 37.6553 37.2373 36.9896C41.3434 34.7688 44.039 30.7502
            43.9218 26.2269C43.7466 19.4663 37.3544 14.1382 29.6443 14.3264Z"
            fill="white"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_731_92566"
        x="0"
        y="0"
        width="60"
        height="60"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.101961 0 0 0 0 0.392157 0 0 0 0 0.831373 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_731_92566"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_731_92566"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_di_731_92566"
        x="12"
        y="12.3215"
        width="35.9258"
        height="35.2407"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.2 0 0 0 0 0.67451 0 0 0 0 0.992157 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_731_92566"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_731_92566"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.412109 0 0 0 0 0.715537 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_731_92566"
        />
      </filter>
      <radialGradient
        id="paint0_radial_731_92566"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.3842 51.34) rotate(-89.1963) scale(10.7084 61.6941)"
      >
        <stop stop-color="#528EE9" />
        <stop
          offset="1"
          stop-color="#145ECE"
        />
      </radialGradient>
      <clipPath id="clip0_731_92566">
        <rect
          width="36"
          height="36"
          fill="white"
          transform="translate(12 10)"
        />
      </clipPath>
    </defs>
  </svg>
</template>